import React from "react";

function WhyLaunchNFT() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Launch Your NFT Collection ?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  NFTs have become a global phenomenon, offering creators an
                  innovative way to monetize their work while providing buyers
                  with verifiable ownership of digital assets. Whether you're a
                  digital artist, musician, game developer, or brand, launching
                  an NFT collection unlocks new revenue streams and strengthens
                  community engagement.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyLaunchNFT;
